<!-- <mat-toolbar color="primary">
    <button [fxShow.lt-md]="true" [fxShow]="false"  mat-icon-button (click)="openSidenav()">
        <mat-icon>menu</mat-icon>
    </button>
    <span>Payment Credit Card</span>
</mat-toolbar> -->
<div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px" [@routeAnimation]="true">
    <mat-tab-group #tabGroupGrants mat-stretch-tabs>

        <mat-tab label="Charitable Contribution">
            <mat-card>
                <mat-tab-group #tabGroupCC mat-stretch-tabs *ngIf="tabGroupGrants.selectedIndex === 0">
                    <mat-tab label="Process Credit Card Payment">
                        <mat-card>
                            <payment-credit-table-component *ngIf="tabGroupCC.selectedIndex === 0" [data]='FormccToPayAsCreditDetails' [displayedColumns]='displayedColumnsFormccToPayAsCredit'>
                            </payment-credit-table-component>
                        </mat-card>
                    </mat-tab>

                    <mat-tab label="Processed As Credit Card">
                        <mat-card>
                            <payment-credit-table-component *ngIf="tabGroupCC.selectedIndex === 1" [data]='FormCCPaidDetails' [displayedColumns]='displayedColumnsFormCCPaidDetails'>
                            </payment-credit-table-component>
                        </mat-card>
                    </mat-tab>
                </mat-tab-group>
            </mat-card>
        </mat-tab>

        <mat-tab label="Community Grants">
            <mat-card>
                <mat-tab-group #tabGroupCG mat-stretch-tabs *ngIf="tabGroupGrants.selectedIndex === 1">
                    <mat-tab label="Process Credit Card Payment">
                        <mat-card>
                            <payment-credit-ext-table-component *ngIf="tabGroupCG.selectedIndex === 0" [data]='FormCGToPayAsCreditDetails' [displayedColumns]='displayedColumnsFormExtCGPPToPayAsCredit'>
                            </payment-credit-ext-table-component>
                        </mat-card>
                    </mat-tab>

                    <mat-tab label="Processed As Credit Card">
                        <mat-card>
                            <payment-credit-ext-table-component *ngIf="tabGroupCG.selectedIndex === 1" [data]='FormCGPaidDetails' [displayedColumns]='displayedColumnsFormExtCGPPPaidDetails'>
                            </payment-credit-ext-table-component>
                        </mat-card>
                    </mat-tab>
                </mat-tab-group>
            </mat-card>
        </mat-tab>

        <mat-tab label="Plant for the Planet">
            <mat-card>
                <mat-tab-group #tabGroupPP mat-stretch-tabs *ngIf="tabGroupGrants.selectedIndex === 2">
                    <mat-tab label="Process Credit Card Payment">
                        <mat-card>
                            <payment-credit-ext-table-component *ngIf="tabGroupPP.selectedIndex === 0" [data]='FormPPToPayAsCreditDetails' [displayedColumns]='displayedColumnsFormExtCGPPToPayAsCredit'>
                            </payment-credit-ext-table-component>
                        </mat-card>
                    </mat-tab>

                    <mat-tab label="Processed As Credit Card">
                        <mat-card>
                            <payment-credit-ext-table-component *ngIf="tabGroupPP.selectedIndex === 1" [data]='FormPPPaidDetails' [displayedColumns]='displayedColumnsFormExtCGPPPaidDetails'>
                            </payment-credit-ext-table-component>
                        </mat-card>
                    </mat-tab>
                </mat-tab-group>
            </mat-card>

        </mat-tab>

        <mat-tab label="Event Sponsorship">
            <mat-card>
                <mat-tab-group #tabGroupES mat-stretch-tabs *ngIf="tabGroupGrants.selectedIndex === 3">
                    <mat-tab label="Process Credit Card Payment">
                        <mat-card>
                            <payment-credit-ext-table-component *ngIf="tabGroupES.selectedIndex === 0" [data]='FormESToPayAsCreditDetails' [displayedColumns]='displayedColumnsFormExtESToPayAsCredit'>
                            </payment-credit-ext-table-component>
                        </mat-card>
                    </mat-tab>

                    <mat-tab label="Processed As Credit Card">
                        <mat-card>
                            <payment-credit-ext-table-component *ngIf="tabGroupES.selectedIndex === 1" [data]='FormESPaidDetails' [displayedColumns]='displayedColumnsFormExtESPaidDetails'>
                            </payment-credit-ext-table-component>
                        </mat-card>
                    </mat-tab>
                </mat-tab-group>
            </mat-card>
        </mat-tab>

    </mat-tab-group>
</div>






<!-- <mat-tab label="Community Investment Funding">
    <mat-card>
        <mat-tab-group #tabGroupCI mat-stretch-tabs *ngIf="tabGroupGrants.selectedIndex === 2">
            <mat-tab label="Process Credit Card Payment">
                <mat-card>
                    <payment-credit-ext-table-component *ngIf="tabGroupCI.selectedIndex === 0"
                        [data]='FormCIToPayAsCreditDetails' [displayedColumns]='displayedColumnsFormExtToPayAsCredit'>
                    </payment-credit-ext-table-component>
                </mat-card>
            </mat-tab>

            <mat-tab label="Processed As Credit Card">
                <mat-card>
                    <payment-credit-ext-table-component *ngIf="tabGroupCI.selectedIndex === 1"
                        [data]='FormCIPaidDetails' [displayedColumns]='displayedColumnsFormExtPaidDetails'>
                    </payment-credit-ext-table-component>
                </mat-card>
            </mat-tab>
        </mat-tab-group>
    </mat-card>
</mat-tab> -->